var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6666 44.6667L33.4999 33.5L22.3333 44.6667",
    className: "svgStroke",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 33.5V58.625",
    className: "svgStroke",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9219 51.3387C59.6447 49.8543 61.7957 47.5054 63.0353 44.6628C64.2749 41.8202 64.5326 38.6457 63.7677 35.6403C63.0027 32.635 61.2587 29.9699 58.811 28.0658C56.3632 26.1617 53.351 25.127 50.2498 25.125H46.7323C45.8873 21.8566 44.3124 18.8223 42.1259 16.2502C39.9395 13.6782 37.1984 11.6352 34.1087 10.275C31.019 8.91478 27.6612 8.27269 24.2877 8.39698C20.9141 8.52128 17.6126 9.40873 14.6314 10.9926C11.6503 12.5765 9.06691 14.8156 7.07565 17.5416C5.08438 20.2676 3.737 23.4096 3.13481 26.7313C2.53262 30.053 2.69129 33.468 3.59888 36.7195C4.50648 39.971 6.13938 42.9745 8.37483 45.5041",
    className: "svgStroke",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6666 44.6667L33.4999 33.5L22.3333 44.6667",
    className: "svgStroke",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.bc207eac2b3c647c5fa2a3e8ce98f49c.svg";
export { ForwardRef as ReactComponent };